import router from './router'

// Components nao agrupados
import UiHeader from './header'
import UiSidebar from './sidebar'
import UiSearchSelect from './search-select'
import UiSearchSelectFunction from './search-select-function'
import UiSearchSelectCidade from './search-select-cidade'
import UiDateTime from './date-time'
import UiSuperModal from './super-modal'
import UiSwitch from './switch'
import UiClean from './clean'
import UiCallout from './callout'
import UiDatePicker from './date-picker'
import UiSelectDib from './select-dib'
import UiSelectUnidade from './select-unidade'
import UiSelectAlturaLimitada from './select-altura-limitada'

import UiIndice from './indice'
import UiCarrega from './carrega'

import UiTermometer from './termometro'

import UiDatePickerCalendar from './date-picker-calendar'
import UiMsgAssinatura from './msg-assinatura'

import ModalConfirmacao from './modal-confirmacao.vue'

export default {
  ...router,
  UiHeader,
  UiSidebar,
  UiSearchSelect,
  UiSearchSelectFunction,
  UiSearchSelectCidade,
  UiDateTime,
  UiSuperModal,
  UiSwitch,
  UiClean,
  UiIndice,
  UiCarrega,
  UiCallout,
  UiDatePicker,
  UiTermometer,
  UiDatePickerCalendar,
  UiSelectDib,
  UiMsgAssinatura,
  UiSelectUnidade,
  ModalConfirmacao,
  UiSelectAlturaLimitada
}



// WEBPACK FOOTER //
// ./src/components/index.js